var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirImp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.018 8.095l-.028-.266a1.14 1.14 0 00-1.067-1.008l-.224-.014a2.423 2.423 0 00-1.811.7l-2.246 2.227-7.355-.014c-.618 0-1.222.252-1.67.7l-.31.308a.47.47 0 00-.112.406c.042.14.14.252.28.294l5.854 1.597-1.361 1.358-2.47.085a.906.906 0 00-.675.294L7.585 15a.442.442 0 00-.113.392c.042.14.14.238.267.294l3.144 1.19 1.264 3.25c.056.14.182.238.322.252a.409.409 0 00.366-.14l.252-.252c.169-.169.267-.393.295-.673l.084-2.479 1.376-1.344 1.586 5.854c.042.14.154.252.295.294.042.014.07.014.112.014a.436.436 0 00.309-.126l.309-.308a2.37 2.37 0 00.701-1.68v-7.34l2.176-2.184a2.3 2.3 0 00.688-1.919zm-1.08 1.527l-2.275 2.269a.276.276 0 00-.084.196v7.45c0 .49-.197.939-.533 1.289l-.14.14-1.671-6.064a.278.278 0 00-.197-.196c-.028 0-.042-.014-.07-.014-.07 0-.14.028-.196.084l-1.797 1.764a.254.254 0 00-.084.196l-.085 2.577c0 .084-.028.21-.126.294l-.098.099-1.221-3.152a.265.265 0 00-.169-.154l-3.046-1.162.084-.084a.446.446 0 01.295-.126l2.597-.084a.23.23 0 00.183-.084l1.782-1.779a.266.266 0 00.07-.266.277.277 0 00-.196-.196l-6.092-1.667.14-.14a1.82 1.82 0 011.278-.532l7.467.014a.28.28 0 00.197-.084l2.33-2.31a1.83 1.83 0 011.39-.533l.224.014a.57.57 0 01.534.504l.028.266a1.797 1.797 0 01-.52 1.47z",
    fill: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.919,
    cy: 13.301,
    r: 12.801,
    stroke: "#2B2B2B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.949,
    cy: 4.949,
    r: 4.949,
    fill: "#EEF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.308 6.806h-2.26V2.83h2.26v.596H2.76v1.013h1.448v.596H2.76v1.17h1.548v.6zm1.429-1.543L4.74 3.788h.796l.657 1.024.657-1.024h.797L6.639 5.263l1.058 1.543H6.9l-.708-1.097-.707 1.097H4.69l1.047-1.543z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirImp2);
export default __webpack_public_path__ + "static/media/air_imp_2.e9bc362a2a7b13fde761a6d239852558.svg";
export { ForwardRef as ReactComponent };